import { render } from "./TbTh.vue?vue&type=template&id=778520fc"
import script from "./TbTh.vue?vue&type=script&lang=js"
export * from "./TbTh.vue?vue&type=script&lang=js"
script.render = render

export default script